/**
 * Placeholder items for The Alchemist's Table. Used when
 * /api/alchemist-table returns an empty list or fails, so the page
 * never renders truly blank.
 *
 * Once the admin populates real entries via /alchemist-table/admin,
 * live rows take precedence and these are ignored.
 */
export const PLACEHOLDER_ALCHEMIST_ITEMS = [
    {
        id: "placeholder-tarot-journal",
        slug: "tarot-journal-prompts",
        title: "Tarot Journal Prompts",
        category: "Reflection",
        description:
            "A gentle set of prompts to sit with after a card pull — for the mornings when the deck has more to say than it first let on.",
        thumbnail_url:
            "https://images.unsplash.com/photo-1633409361618-c73427e4e206?auto=format&fit=crop&w=1200&q=80",
        download_url: "",
        is_published: true,
        display_order: 30,
    },
    {
        id: "placeholder-lunar-guide",
        slug: "lunar-cycle-guide",
        title: "The Lunar Cycle Guide",
        category: "Astrology",
        description:
            "An intimate walk through the eight phases of the moon and what each one tends to ask of us — a companion to any personal chart work.",
        thumbnail_url:
            "https://images.unsplash.com/photo-1532693322450-2cb5c511067d?auto=format&fit=crop&w=1200&q=80",
        download_url: "",
        is_published: true,
        display_order: 20,
    },
    {
        id: "placeholder-ritual-morning",
        slug: "quiet-morning-ritual",
        title: "A Quiet Morning Ritual",
        category: "Practice",
        description:
            "A short, tender morning practice for people doing deep inner work — no incense required, just five minutes and a willingness to arrive.",
        thumbnail_url:
            "https://images.unsplash.com/photo-1519378058457-4c29a0a2efac?auto=format&fit=crop&w=1200&q=80",
        download_url: "",
        is_published: true,
        display_order: 10,
    },
];
